import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import api_loyalty from "./../api/api";
Vue.use(Vuex);
export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    name: "wfiws-vue-state",
    loginUser: {},
    roleMapping: [],
  },
  mutations: {
    setLoginUser(state, data) {
      state["loginUser"] = data;
    },
    setRoleMapping(state, data) {
      state["roleMapping"] = data;
    },
  },
  actions: {
    async fetchLoginUser({ commit }) {
      let loginuser = {};
      commit("setLoginUser", loginuser);
      await api_loyalty.fetchLoginUser().then((user) => {
        loginuser = {
          id: user.attributes.sub,
          email: user.attributes.email,
          name: user.attributes.email,
          groups: user.signInUserSession.accessToken.payload["cognito:groups"],
          firstName: "",
          lastName: "",
          department: "",
          username: "",
          cognitoGroup: "",
        };
      });
      commit("setLoginUser", loginuser);
      return loginuser;
    },
    async getRoleMapping({ getters, dispatch, commit }) {
      let roleMappingData = [];
      try {
        if (!getters.loginUser.groups) {
          await dispatch("fetchLoginUser");
        }
        const response = await api_loyalty.GetRoleMapping(getters.loginUser.groups);
        if(response.isSuccess){
          roleMappingData = response.data;
        }
      } catch {
        roleMappingData = [];
      }
      commit("setRoleMapping", roleMappingData);
      return roleMappingData;
    },
  },
  getters: {
    loginUser: (state) => state.loginUser,
    isLoginUserAdmin: (state) => {
      let env = api_loyalty.AllConfig().api_url.Tools_Env;
      let aws_user_pools_id = api_loyalty.AllConfig().cognito.aws_user_pools_id;
      let ssoGroupName = aws_user_pools_id + "_wfiws-ems" + env + "-admin-sso";
      return (
        state.loginUser.groups &&
        (state.loginUser.groups.includes("Administrator") ||
          state.loginUser.groups.includes(ssoGroupName))
      );
    },
    roleMappingData: (state) => state.roleMapping,
    isFortuneAdmin: (state) => {
      return (
        state.loginUser.groups &&
        state.loginUser.groups.includes("PHFortuneAdmin")
      );
    },
    isCheAdmin: (state) => {
      return (
        state.loginUser.groups && state.loginUser.groups.includes("PHCheAdmin")
      );
    },
    isCheReader: (state) => {
      return (
        state.loginUser.groups && state.loginUser.groups.includes("PHCheReader")
      );
    },
    isFortuneReader: (state) => {
      return (
        state.loginUser.groups &&
        state.loginUser.groups.includes("PHFortuneReader")
      );
    },
    isVendorHotline: (state) => {
      return (
        (state.loginUser.groups &&
          state.loginUser.groups.includes("PHVendorHotline")) ||
        (state.loginUser.groups &&
          state.loginUser.groups.includes("PHCHEVendorHotline")) ||
        (state.loginUser.groups &&
          state.loginUser.groups.includes("PHFTVendorHotline"))
      );
    },
  },
});

export default store;
